import type { ColumnDef } from '@tanstack/react-table';

import { GetDeliveryQuery } from 'data/__generated__';
import { numberColumn } from 'components/DataTable';

import { StatusTag } from 'pages/Orders/components/StatusTag';

export type DeliveryOrderRow = NonNullable<GetDeliveryQuery['delivery']>['orders'][number];

type DeliveryOrdersFilter = { searchValue?: string };

export const deliveryOrdersColumns: ColumnDef<DeliveryOrderRow, unknown>[] = [
    numberColumn<DeliveryOrderRow, DeliveryOrdersFilter>({
        accessorKey: 'number',
        header: 'N° commande',
        defaultVisible: true,
    }),
    {
        id: 'client',
        header: 'Client',
        accessorFn: (row) => row.user?.profile?.fullname ?? '',
        cell: ({ row }) => <span>{row.original.user?.profile?.fullname ?? '—'}</span>,
        meta: { defaultVisible: true },
    },
    {
        id: 'state',
        header: 'Statut',
        accessorFn: (row) => row.state,
        cell: ({ row }) => <StatusTag state={row.original.state} />,
        meta: { defaultVisible: true },
    },
];
